import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';

import client from '@/apis/aniftyBackend/client';
import { LikedCreationList } from '@/apis/aniftyBackend/users/interface';

const fetchUserLikedCreations = async (
  userID: string,
  pageToken: string | undefined
) => {
  const response = await client.get<LikedCreationList>(
    `/api/users/${userID}/liked_creations`,
    {
      params: { page_token: pageToken },
    }
  );
  return response.data;
};

export const buildQueryKey = (userID: string) =>
  [`/users/liked_creations`, userID] as const;

const useFetchUserLikedCreations = (
  userID: string | undefined
): UseInfiniteQueryResult<LikedCreationList> => {
  return useInfiniteQuery({
    queryKey: userID ? buildQueryKey(userID) : undefined,
    queryFn: userID
      ? ({ pageParam }) => fetchUserLikedCreations(userID, pageParam)
      : undefined,
    getNextPageParam: userID ? (lastPage) => lastPage.nextPageToken : undefined,
  });
};

export default useFetchUserLikedCreations;
